$('.pricing-block__toggle').click(function (e) {
    e.preventDefault();
    let $this = $(this);
    let $hash = $this.attr('href');
    $('.pricing-block:not(' + $hash + ') .pricing-block--accordion__content').slideUp();
    $('.pricing-block').removeClass('active');
    $($hash + ' .pricing-block--accordion__content').slideToggle();
    if (window.location.hash === $hash) {
        window.history.replaceState({}, document.title, window.location.pathname);
    } else {
        window.history.replaceState({}, document.title, window.location.pathname + $hash);
        $($hash).addClass('active');
    }
});
